$(function(){
	$('.mega-menu').hide();
	var main_header = $('.main-header');
	var mh_offset = main_header.offset().top;
 	if($('nav.block-menu').length){
		var nav = $('nav.block-menu');
	}
	if($('.block-menu-item-fields').length){
		var nav = $('div.block-menu-item-fields');
	}
	if(nav){		
		var sticky = Math.abs(nav.offset().top);	
		$(window).on('scroll', function(){
			console.log($(window).scrollTop());
			 if($(window).scrollTop() >= sticky){
			 	nav.addClass('fixed-top');
			 }else{
			 	nav.removeClass('fixed-top');
			 }
		});
	}
	$(window).on('scroll', function(){
		if($(window).scrollTop() >= mh_offset){
			$('.mega-menu').show();
		}else{
			console.log('hide');
			$('.mega-menu').hide();
		}
	});
});